import { Locale } from '../app/_shared/services/app.service';

export const supportedLanguages: Locale[] = [
    { locale: 'de-DE', flag: 'de', salesOrg: '0500' },
    { locale: 'en-DE', flag: 'de', salesOrg: '0500' },
    { locale: 'en-GB', flag: 'gb', salesOrg: '6800' },
];
